<template>
  <div class="story-content" :style='cssVars'>
    <h2 v-if="story.title">{{ story.title }}</h2>
    <p v-for="(paragraph, index) in story.paragraphs" :key="index" v-html="paragraph"></p>
    <p v-if="story.footnote"><small>{{ story.footnote }}</small></p>
  </div>
</template>

<script>
export default {
  name: 'ScrollStory',
  components: {
  },
  props: {
    story: Object,
    innerHeight: {
      type: Number,
      required: true,
      default: 800
    }
  },
  data() {
    const viewportHeight = this.innerHeight;
    return {
      viewportHeight
    }
  },
  methods: {
  },
  computed: {
    /* Variables you want to pass to CSS */
    cssVars () {
      return {
        '--storyMarginBottom': this.viewportHeight * 0.95 + 'px',
        '--lastChildMarginBottom': this.viewportHeight * 0.2 + 'px',
        '--lastChildPaddingTop': this.viewportHeight * 0.45 + 'px'
      }
    }
  },
  created() {
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.story-content {
  // margin-bottom: var(--storyMarginBottom);
  margin-bottom: 95vh;
  background: rgba(0,0,0,0.8);
  color: #fff;
  padding: 20px;
  line-height: 1.4;

  h2 {
    font-family: 'Open Sans', Arial, sans-serif !important;
    font-size: 18px;
    margin: 0;
  }

  p {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 24px;

    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 27px;
    }
  }

  &:nth-last-child(2) {
    // margin-bottom: var(--lastChildMarginBottom);
    margin-bottom: 20vh;
    background: transparent;
  }

  &:last-child {
    // padding-top: var(--lastChildPaddingTop);
    padding-top: 45vh;
    margin-bottom: 0;
    background: transparent;
  }

  &.first {
    margin-top: 0;
  }

  > p:last-child {
    margin-bottom: 0;
  }

  > p:first-child {
    margin-top: 0;
  }
}
</style>